export const DislikeIcon = ({ fill = '#E92E4A' }) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12H18V0H21C21.2652 0 21.5196 0.105357 21.7071 0.292893C21.8946 0.48043 22 0.734784 22 1V11C22 11.2652 21.8946 11.5196 21.7071 11.7071C21.5196 11.8946 21.2652 12 21 12ZM15.707 13.293L9.307 19.693C9.22194 19.7783 9.10894 19.83 8.98878 19.8387C8.86862 19.8473 8.74939 19.8123 8.653 19.74L7.8 19.1C7.5631 18.9222 7.38416 18.6781 7.28575 18.3987C7.18733 18.1193 7.17385 17.8171 7.247 17.53L8.4 13H2C1.46957 13 0.96086 12.7893 0.585788 12.4142C0.210715 12.0391 1.0643e-06 11.5304 1.0643e-06 11V8.896C-0.000268556 8.63464 0.050692 8.37576 0.150001 8.134L3.246 0.62C3.32128 0.436753 3.4493 0.279995 3.6138 0.169612C3.77831 0.0592292 3.97189 0.00019547 4.17 0H15C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V12.586C15.9999 12.8512 15.8946 13.1055 15.707 13.293Z"
        fill={fill}
      />
    </svg>
  );
};
